export default __webpack_public_path__ + "static/media/socks.53224ed2.png";